export default __webpack_public_path__ + "static/graph-99d828d714f85054879222095194f2a6.svg";